import axios from 'axios'
import Constants from './constants'
import router from "./router";
import { store }  from './store';

export default function setup() {
    axios.interceptors.request.use(function(config) {
        const token = localStorage.getItem(Constants.accessToken);
        if(token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, function(err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401) {
            store.commit('admins/setIsLoggedIn', false);
            store.commit('admins/setUser', null);
            store.commit('admins/resetLoginAttempts')
            router.push('/signin');
        }
        return Promise.reject(error)
    })
}